import { render } from "./ArrowBackIcon.vue?vue&type=template&id=25d8503a"
import script from "./ArrowBackIcon.vue?vue&type=script&lang=js"
export * from "./ArrowBackIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__